/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_TracingInputs */

const en_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracing`)
};

const ar_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التتبع`)
};

const bn_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্রেসিং`)
};

const de_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablaufverfolgung`)
};

const es_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento`)
};

const fr_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traçage`)
};

const pt_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamento`)
};

const zh_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追踪`)
};

const tr_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzleme`)
};

const ru_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трассировка`)
};

const pl_svchip_tracing = /** @type {(inputs: Svchip_TracingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzenie`)
};

/**
* | output |
* | --- |
* | "Tracing" |
*
* @param {Svchip_TracingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_tracing = /** @type {((inputs?: Svchip_TracingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_TracingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_tracing(inputs)
	if (locale === "bn") return bn_svchip_tracing(inputs)
	if (locale === "de") return de_svchip_tracing(inputs)
	if (locale === "es") return es_svchip_tracing(inputs)
	if (locale === "fr") return fr_svchip_tracing(inputs)
	if (locale === "pt") return pt_svchip_tracing(inputs)
	if (locale === "zh") return zh_svchip_tracing(inputs)
	if (locale === "tr") return tr_svchip_tracing(inputs)
	if (locale === "ru") return ru_svchip_tracing(inputs)
	if (locale === "pl") return pl_svchip_tracing(inputs)
	return en_svchip_tracing(inputs)
});